import { useSelector } from "react-redux"
import { State } from "../state/store"
import { DateTime } from "luxon"
import { useCallback } from "react"

export const useGetDate = () => {
	const { overriddenDate } = useSelector((state: State) => state.environment)

	const getDate = useCallback(() => {
		const today = DateTime.utc()

		return overriddenDate
			? DateTime.fromISO(`${overriddenDate}T${today.toISOTime()}`)
			: today
	}, [overriddenDate])

	return getDate
}

export const getStartOfPreviousMonth = (start: DateTime): DateTime =>
	start.plus({ month: -1 }).startOf("month")

export const getEndOfPreviousMonth = (start: DateTime): DateTime =>
	start.plus({ month: -1 }).endOf("month").startOf("day")

export const minusDays = (start: DateTime, days: number): DateTime =>
	start.minus({ day: days })

export default useGetDate
